import React from 'react';
import cn from 'classnames';
import { FormLabel } from "../../../../Typography";
import ScreenReaderOnlyText from "../../../../../helpers/ScreenReaderOnlyText/ScreenReaderOnlyText";
import "./BaseInputLabel.css";
var styles = { "label": "f99ba9", "label_disabled": "cc1f6b", "label_required": "a1aa41" };
const BaseInputLabel = ({ children, name, id, isRequired, isDisabled, isLabelVisible = true, }) => isLabelVisible ? (React.createElement(FormLabel, { htmlFor: id || name, className: cn(styles.label, isDisabled && styles.label_disabled), isRequired: isRequired }, children)) : (React.createElement(ScreenReaderOnlyText, { Tag: "label", htmlFor: id || name }, children));
export default BaseInputLabel;
//# sourceMappingURL=BaseInputLabel.js.map